import { render, staticRenderFns } from "./RedirectPage.vue?vue&type=template&id=24e47668&scoped=true&"
import script from "./RedirectPage.vue?vue&type=script&lang=js&"
export * from "./RedirectPage.vue?vue&type=script&lang=js&"
import style0 from "./RedirectPage.vue?vue&type=style&index=0&id=24e47668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e47668",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VRow,VTextField})
